import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDataTable,{staticClass:"elevation-1 evidenciada",attrs:{"headers":_vm.headersTarefas,"items":_vm.tasks,"item-key":"municipioTarefaId","loading-text":"Obtendo informações ...","hide-default-footer":"","disable-pagination":"","loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }